import { GET_REMAINING_SCANS } from 'modules/App/queries/queries';
import request from 'utils/request';

interface Response {
  data: number;
}

const getRemainingScans = async (): Promise<Response> => {
  const endpoint = '/ocr/remaining';

  const response = await request<any>(endpoint, {
    method: 'get',
  });

  return {
    ...response.data,
  };
};

export const invalidateQueries = [GET_REMAINING_SCANS];

export default getRemainingScans;
